import React from 'react'
import ReferencesCard from '../components/References/ReferencesCard'

const References = () => {
    return (
        <div>
            <ReferencesCard />
        </div>
    )
}

export default References
